import { useTimeoutFn } from '@vueuse/core'

const REVOKE_AFTER_DOWNLOAD_STARTS_MS = 1000

/** Saves a Blob through a temporary link, so the browser names the file as the server did. Safari and Firefox
 *  start the download asynchronously, so the object URL is released only after a delay. */
export const downloadBlob = (blob: Blob, filename: string): void => {
  const href = URL.createObjectURL(blob)
  const link = document.createElement('a')

  link.href = href
  link.download = filename
  link.click()

  useTimeoutFn(() => URL.revokeObjectURL(href), REVOKE_AFTER_DOWNLOAD_STARTS_MS)
}
